module.exports = __webpack_public_path__ + "img/welcome-banner@3x.19f61623.png";